<template>
  <div class="wrapper">
    <h1 class="van-hairline--bottom">法人实名注册协议</h1>
    <p>1.【目的意义】为保证网上政务服务用户信息的真实性、合法性和有效性， 自然人、法人用户注册、验证应采用实名制。统一用户注册和验证是开展“互联 网+政务服务”、建立政务服务实施机构和行政相对人线上服务法律关系的前提， 是今后全国政务服务实现网上“一地注册，各地互认”的基础。在您成为“互联 网+政务服务”法人注册用户（简称“法人用户”）之前，请确认您已充分阅读、 理解并接受本协议的全部内容，同意遵循本协议的所有约定。</p>
    <p>2.【协议适用主体范围】政务服务门户的运营管理权归政务服务机构所有。 本协议是由依法设立的法人组织与湖北省政务服务管理机构（简称“政务服务机 构”），明确双方通过湖北省政务服务门户和平台办理政务服务事项过程中的权利 义务所订立的协议。</p>
    <p>3.【服务内容】法人用户能够访问互联网政务服务门户网站、检索静态信息、 进行在线咨询、申办政务服务事项，可在专属用户空间查询所办事项的过程信息 和历史信息，储存信息资料，维护用户空间信息，并对政务服务事项的经办人进 行分级分类授权管理。</p>
    <p>4.【用户承诺与授权】法人用户在政务服务门户进行注册和使用政务服务平 台时承诺并确认：</p>
    <p>(1)提供及时、详尽及准确的法人资料；</p>
    <p>(2)及时更新法定代表人、联系人及经办人等关联信息；</p>
    <p>(3)同意接收政务服务机构推送的信息；</p>
    <p>(4)在提请政务服务事项办理过程中，按服务内容要求提供真实、准确的要 件材料，并及时对上传本平台的要件材料做好更新维护；</p>
    <p>(5)自愿选择物流快递、网上支付等第三方服务时，及时提供真实姓名、联 系地址、联系方式、账户等相关个人信息；</p>
    <p>(6)不存放与政务服务申办无关的信息内容。</p>
    <p>5.【用户信息保障】政务服务机构依法保护个人隐私，不得违法违规向与政 务服务无关的第三方提供用户注册资料。</p>
    <p>6.【用户的密码和安全性】考虑到法人用户是特定的行政相对人，其账号由法定代表人、联系人和委托经办人实际操作，其行为应由法人承担相应法律责任。 上述用户应妥善保管密码，不得将账号、密码提供给他人使用。建议定期修改密 码，以确保账号安全。</p>
    <p>7.【禁止条款】法人用户有违反法律法规行为的，政务服务机构有权终止为 用户提供服务，并保留追责的权利。</p>
    <p>8.【注意事项】政务服务机构将加强网络安全管理和风险防控，因技术原因 和网络中断等因素，可能会造成法人用户的实时操作无效或暂停，请注意备份相 关资料。</p>
    <p>9.【其他规定】政务服务机构后期依照本服务条款及相关法律法规发布的补 充规则，均为本协议不可分割的组成部分，原则上不再重复另行签约。</p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.wrapper {
  h1 {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    height: 30px;
    line-height: 30px;
    margin-bottom: 20px;
    padding-bottom: 4px;
  }
  p {
    text-indent: 2em;
    font-size: 12px;
    line-height: 20px;
    color: #999;
    letter-spacing: 1px;
    text-align: justify;
  }
}
</style>